angular.module('TetherApp').controller('SmsController', [
    '$anchorScroll',
    '$location',
    '$window',
    '$timeout',
    'smsService',
    'modelLockService',
    '$interval',
    function (
        $anchorScroll,
        $location,
        $window,
        $timeout,
        smsService,
        modelLockService,
        $interval
    ) {

        let self = this;
        let redirectTo = '/experience/sms';

        self.smsList = {};
        self.sms = {};
        self.sms.optin_type = 1;
        self.currentPage = 1;
        self.mergeData = [];

        //Model Lock
        self.modelLock;
        self.experienceLockTimeRemainingDisplay;
        self.experienceLockTimeEndDisplay;
        self.experienceLockCountdown = undefined;

        self.index = function (page) {
            self.currentPage = page;
            smsService.indexSms(self.currentPage)
                .then(onIndex, onError);
        };

        let onIndex = function (data) {
            self.smsList = data.data;
        };

        //START: SHOW SERVICE FUNCTIONS
        self.show = function (data) {
            self.sms = JSON.parse(data);

            self.has_merge_data = (self.has_merge_data == '1') ? true : false;
            self.getExperienceLock();
        };
        //END: SHOW SERVICE FUNCTIONS

        //START: STORE SERVICE FUNCTIONS
        self.store = function () {
            let tempSms = self.sms;

            smsService.storeSms(tempSms)
                .then(onStore, onError);
        };

        let onStore = function (data) {
            $window.location.href = '/' + self.client_eid + redirectTo;
        };
        //END: STORE SERVICE FUNCTIONS

        //START: UPDATE SERVICE FUNCTIONS
        self.update = function () {
            let tempSms = self.sms;

            smsService.updateSms(tempSms)
                .then(onUpdate, onError);
        };

        let onUpdate = function (data) {
            self.releaseExperienceLock();
            $window.location.href = '/' + self.client_eid + redirectTo;
        };
        //END: UPDATE SERVICE FUNCTIONS

        //START: DESTROY SERVICE FUNCTIONS
        self.delete = function (smsId) {
            if ($window.confirm(self.deleteText.replace(':id', smsId))) {
                smsService.deleteSms(smsId)
                    .then(onDelete, onError);
            }
        };

        let onDelete = function (data) {
            window.location.reload();
        };
        //END: DESTROY SERVICE FUNCTIONS

        //START: GENERAL SERVICE FUNCTIONS
        let onError = function (data) {
            $location.hash('top');
            $anchorScroll();
            self.errors = data.data.errors;
        };

        let redirectToIndex = function () {
            $window.location.href = '/' + self.client_eid + redirectTo;
        };
        //END: GENERAL SERVICE FUNCTIONS

        //START: MERGE SERVICE FUNCTIONS
        self.getMergeData = function (smsId) {
            smsService.getMergeData(self.client_eid, smsId)
                .then(onGetMergeData, onError);
        };

        let onGetMergeData = function (data) {
            self.mergeData = data;
        };
        //END: MERGE SERVICE FUNCTIONS

        //START: MERGE SERVICE FUNCTIONS
        self.deleteMergeData = function (mergeDataId) {
            smsService.deleteMergeData(mergeDataId)
                .then(onDeleteMergeData, onError);

        };

        let onDeleteMergeData = function (data) {
            $window.location.reload();
        };
        //END: MERGE SERVICE FUNCTIONS

        //START: EXPERIENCE EDIT TIMER

        self.getExperienceLock = function() {
            let lockData = {
                'type': 'editing',
                'model_id': self.sms.experience.eid,
                'model_type': 'experience',
            };
            modelLockService.lock(lockData).then(initiateExperienceLock, onError);
        }

        self.extendExperienceLock = function() {
            let lockData = {
                'type': 'editing',
                'model_id': self.sms.experience.eid,
                'model_type': 'experience',
            };
            modelLockService.extend(lockData).then(initiateExperienceLock, onError);
        };

        self.releaseExperienceLock = function() {
            let lockData = {
                'type': 'editing',
                'model_id': self.sms.experience.eid,
                'model_type': 'experience',
            };
            modelLockService.release(lockData);
        };

        let initiateExperienceLock = function(modelLock) {
            self.modelLock = modelLock;
            self.experienceLockTimeEndDisplay = self.DisplayTime(modelLock.lock_expired_at);
            self.initiateExperienceLockCountdown(modelLock.seconds_left);
        };

        self.initiateExperienceLockCountdown = function (seconds) {
            let then = Date.now() + seconds * 1000;
            if (angular.isDefined(self.experienceLockCountdown)) {
                $interval.cancel(self.experienceLockCountdown);
                self.experienceLockCountdown = undefined
            }
            self.experienceLockCountdown = $interval(function () {
                let secondsLeft = Math.round((then - Date.now()) / 1000);
                if (secondsLeft < 0) {
                    self.experienceLockTimeRemainingDisplay = '0:00';
                    redirectToIndex();
                    $interval.cancel(self.experienceLockCountdown);
                } else {
                    let minutes = Math.floor(secondsLeft / 60);
                    let remainderSeconds = secondsLeft % 60;
                    self.experienceLockTimeRemainingDisplay = minutes + ':' + (remainderSeconds < 10 ? '0' : '') + remainderSeconds;
                    if (secondsLeft === 300) {
                        self.showExtendLock();
                    }
                }
            }, 1000);
        };

        self.DisplayTime = function(timestamp) {
            let end = new Date(timestamp);
            let hour = end.getHours();
            let adjustedHour = hour > 12 ? hour - 12 : hour;
            let minutes = end.getMinutes();
            return adjustedHour + ':' + (minutes < 10 ? '0' : '') + minutes;
        };

        self.showExtendLock = function() {
            var confirm = $mdDialog.confirm()
                    .title('Would you like to extend experience lock?')
                    .textContent('User will be redirected to index page without saving when timer runs out.')
                    .ariaLabel('Timer Dialog')
                    .ok('Extend Lock')
                    .cancel('Close');
            $mdDialog.show(confirm).then(function() {
                self.extendExperienceLock();
            }, function() {
                // this is close
            });
        };
        //END: EXPERIENCE EDIT TIMER
    }
]);
